module.exports = __webpack_public_path__ + "static/img/product-4.88fb7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-4.png
// module id = bXiY
// module chunks = 0